import { withStyles } from '@material-ui/core';

import FinishButton from './component';
import styles from './styles';

export default withStyles(styles)(FinishButton);
